// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27aY9","placeholdersHeader":"styles_placeholdersHeader__2mnAc","editorStyle":"styles_editorStyle__RWlFa","placeholdersBox":"styles_placeholdersBox__241DN"};